import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { MultiAllocProductRenderer } from "app/bfx-blotter-common/renderers/MultiAllocProductRenderer";

@NgModule({
  declarations: [MultiAllocProductRenderer],
  imports: [CommonModule],
  exports: [MultiAllocProductRenderer],
  providers: [],
})
export class BfxBlotterCommonModule {}
